import * as React from 'react';

import { Button } from '@components/button';

import * as Styled from './pagination.styled.ts';

type OwnProps = {
	currentPage: number;
	totalPages: number;
	onPageChange: (page: number) => void;
};

const Pagination: React.FC<OwnProps> = ({ currentPage, totalPages, onPageChange }) => {
	const maxPages = 5;
	const [startPage, setStartPage] = React.useState(1);

	const handleNextClick = () => {
		if (startPage + maxPages <= totalPages) {
			setStartPage(startPage + maxPages);
		} else {
			setStartPage(totalPages - maxPages + 1);
		}
	};

	const handlePrevClick = () => {
		if (startPage - maxPages >= 1) {
			setStartPage(startPage - maxPages);
		} else {
			setStartPage(1);
		}
	};

	const renderPages = () => {
		const pages = [];

		for (let i = startPage; i < startPage + maxPages && i <= totalPages; i++) {
			pages.push(
				<Button color={i === currentPage ? 'dark' : 'neutral'} variant='round' key={i} onClick={() => onPageChange(i)}>
					{i}
				</Button>
			);
		}

		return pages;
	};

	return (
		<Styled.Wrapper>
			{startPage > 1 && (
				<Button onClick={handlePrevClick} hasIcon iconPosition='start' color='neutral' variant='round' />
			)}
			{renderPages()}
			{startPage + maxPages <= totalPages && (
				<Button onClick={handleNextClick} hasIcon iconPosition='end' color='neutral' variant='round' />
			)}
		</Styled.Wrapper>
	);
};

export default Pagination;
